import React, { useEffect } from "react";

// routing
import { NavLink as Link } from "react-router-dom";

// alert
import { warning } from "../../util/Alert";

// redux
import { useDispatch } from "react-redux";

// types
import { UNSET_ADMIN } from "../../store/admin/types";

//MUI

// jquery
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import { projectName } from "../../util/Config";
import { adminNavbarConfig } from "../../util/constants";
import { usePermission } from "../../context/PermissionProvider";

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { canSee } = usePermission();

  const handleLogout = () => {
    const data = warning();
    data.then((isLogout) => {
      if (isLogout) {
        dispatch({ type: UNSET_ADMIN });
        navigate("/");
      }
    });
  };

  useEffect(() => {
    $("").addClass("submenu-margin");
  }, []);

  return (
    <>
      <div className="page-sidebar">
        <Link to="/admin/dashboard">
          <span className="logo text-danger text-capitalize">
            {projectName}
          </span>
        </Link>
        <ul className="list-unstyled accordion-menu">
          {/* Dashboard */}
          <li className="sidebar-heading">DASHBOARD</li>
          <li
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Dashboard"
          >
            <Link to="/admin/dashboard" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="activity"></i>
              </span>
              Dashboard
            </Link>
          </li>

          {adminNavbarConfig.map((item, index) => {
            // ── Heading render ──────────────────────────────
            if (item.type === "heading") {
              // Only show heading if at least one item below it (before next heading) is visible
              let sectionHasVisible = false;
              for (let i = index + 1; i < adminNavbarConfig.length; i++) {
                const nextItem = adminNavbarConfig[i];
                if (nextItem.type === "heading") break;
                if (nextItem.children) {
                  if (
                    nextItem.children.some((child) =>
                      canSee((child.path || "").replace(/^\//, "")),
                    )
                  ) {
                    sectionHasVisible = true;
                    break;
                  }
                } else {
                  if (canSee((nextItem.path || "").replace(/^\//, ""))) {
                    sectionHasVisible = true;
                    break;
                  }
                }
              }
              if (!sectionHasVisible) return null;

              return (
                <li key={index} className="sidebar-heading">
                  {item.label}
                </li>
              );
            }

            // ── Children (dropdown) render ──────────────────
            if (item.children) {
              const visibleChildren = (item.children || []).filter((child) => {
                const key = (child.path || "").replace(/^\//, "");
                return key && canSee(key);
              });

              if (!visibleChildren.length) return null;

              return (
                <li key={index} className="pointer-cursor">
                  <a
                    href="#"
                    className="add-collapse-margin"
                    style={{ marginLeft: 0 }}
                  >
                    <span className="sidenav__icon">{item.icon}</span>
                    {item.name}
                    <i className="fas fa-chevron-right dropdown-icon"></i>
                  </a>

                  <ul>
                    {visibleChildren.map((child, childIndex) => {
                      const childKey = (child.path || "").replace(/^\//, "");
                      if (!childKey || !canSee(childKey)) return null;

                      return (
                        <li key={childIndex}>
                          <Link
                            to={child.path}
                            className="nav-link"
                            onClick={child.onClick}
                          >
                            <i className="far fa-circle"></i> {child.name}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </li>
              );
            }

            // ── Single item render ──────────────────────────
            const path = item.path || "";
            const key = path.replace(/^\//, "");
            if (!key || !canSee(key)) return null;

            return (
              <li key={index}>
                <Link to={item.path} className="nav-link">
                  <span className="sidenav__icon">{item.icon}</span>
                  {item.name}
                </Link>
              </li>
            );
          })}

          {/* Profile */}
          <li>
            <Link to="/admin/adminProfile" className="nav-link">
              <span className="sidenav__icon">
                <i data-feather="user"></i>
              </span>
              Profile
            </Link>
          </li>

          {/* Logout */}
          <li>
            <a
              href="#"
              onClick={handleLogout}
              className="add-collapse-margin cursor-pointer"
            >
              <span className="sidenav__icon">
                <i data-feather="log-out"></i>
              </span>
              Logout
            </a>
          </li>
        </ul>

        <a
          href={() => false}
          id="sidebar-collapsed-toggle"
          style={{ opacity: 0, pointerEvents: "none" }}
        >
          <i data-feather="arrow-right"></i>
        </a>
      </div>
    </>
  );
};
export default Navbar;
